import { render, staticRenderFns } from "./addGame.vue?vue&type=template&id=5074834a&scoped=true&"
import script from "./addGame.vue?vue&type=script&lang=js&"
export * from "./addGame.vue?vue&type=script&lang=js&"
import style0 from "./addGame.vue?vue&type=style&index=0&id=5074834a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074834a",
  null
  
)

export default component.exports